import { Component, Injectable, defineInjectable, inject, NgModule } from '@angular/core';
import { MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AngularMaterialModule, UtilsModule, LoggerService, ConsoleLoggerService } from 'utils';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CommandBarComponent = /** @class */ (function () {
    function CommandBarComponent() {
    }
    /**
     * @return {?}
     */
    CommandBarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    CommandBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'crm-command-bar',
                    template: "<mat-toolbar class=\"crm-command-bar\" fxHide.xs>\n\n  <mat-toolbar-row class=\"crm-command-bar-row\">\n\n    <ng-content> </ng-content>\n\n  </mat-toolbar-row>\n\n</mat-toolbar>\n\n<!--\n\n<mat-toolbar class=\"crm-command-bar-height\">\n\n  <mat-toolbar-row class=\"crm-command-bar-height\">\n\n    <ng-content> </ng-content>\n\n  </mat-toolbar-row>\n\n</mat-toolbar>\n\n\n-->\n\n<!--\n\n<mat-toolbar class=\"command-bar-height\">\n\n  <mat-toolbar-row class=\"command-bar-height\">\n\n    <button mat-button class=\"command-bar-button\">\n      <mat-icon>add</mat-icon>\n      NEW\n    </button>\n\n    <button mat-button class=\"command-bar-button\" [disabled]=\"true\">\n      <mat-icon>visibility</mat-icon>\n      ACTIVATE\n    </button>\n\n    <button mat-button class=\"command-bar-button\">\n      <mat-icon>visibility_off</mat-icon>\n      DEACTIVATE\n    </button>\n\n    <button mat-button class=\"command-bar-button\">\n      <mat-icon>link</mat-icon>\n      EMAIL A LINK\n    </button>\n\n    <button mat-button class=\"command-bar-button\">\n      <mat-icon>description</mat-icon>\n      RUN REPORT\n    </button>\n\n    <div fxFlex fxLayout fxLayoutAlign=\"flex-end\">\n\n      <button mat-button class=\"command-bar-button\">\n        <mat-icon>open_in_new</mat-icon>\n      </button>\n\n    </div>\n\n  </mat-toolbar-row>\n\n</mat-toolbar>\n\n\n\n      <button mat-button class=\"command-bar-button\">\n        <mat-icon>more_horiz</mat-icon>\n      </button>\n\n      <button mat-button class=\"command-bar-button\">\n        <mat-icon>delete</mat-icon>\n        DELETE\n      </button>\n\n    <div class=\"command-bar-container\">\n\n-->\n",
                    styles: [".crm-command-bar-row{height:56px!important;min-height:56px!important;padding-left:8px;padding-right:8px}@media (max-width:599px){.crm-command-bar-row{height:0!important;min-height:0!important}}.crm-command-bar-button{min-width:48px;padding:0 16px}"]
                }] }
    ];
    /** @nocollapse */
    CommandBarComponent.ctorParameters = function () { return []; };
    return CommandBarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActivityBarComponent = /** @class */ (function () {
    function ActivityBarComponent() {
    }
    /**
     * @return {?}
     */
    ActivityBarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ActivityBarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'crm-activity-bar',
                    template: "<mat-toolbar class=\"crm-activity-bar\">\n\n  <mat-toolbar-row class=\"crm-activity-bar-row\">\n\n    <ng-content> </ng-content>\n\n  </mat-toolbar-row>\n\n</mat-toolbar>\n",
                    styles: [".crm-activity-bar-row{height:56px!important;min-height:56px!important;padding-left:24px;padding-right:24px}@media (max-width:599px){.crm-activity-bar-row{height:48px!important;min-height:48px!important}}::ng-deep .crm-activity-bar-menu-button{min-width:32px!important;padding:0!important}::ng-deep .mat-menu-content{padding-top:0!important;padding-bottom:0!important}::ng-deep .mat-menu-item{line-height:40px!important;height:40px!important}"]
                }] }
    ];
    /** @nocollapse */
    ActivityBarComponent.ctorParameters = function () { return []; };
    return ActivityBarComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SidenavService = /** @class */ (function () {
    function SidenavService() {
        this.opened = false;
    }
    /**
     * @param {?} sidenav
     * @return {?}
     */
    SidenavService.prototype.setSidenav = /**
     * @param {?} sidenav
     * @return {?}
     */
    function (sidenav) {
        this.sidenav = sidenav;
    };
    /**
     * @return {?}
     */
    SidenavService.prototype.open = /**
     * @return {?}
     */
    function () {
        this.opened = true;
        return this.sidenav.open();
    };
    /**
     * @return {?}
     */
    SidenavService.prototype.close = /**
     * @return {?}
     */
    function () {
        this.opened = false;
        return this.sidenav.close();
    };
    /**
     * @return {?}
     */
    SidenavService.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.opened = !this.opened;
        return this.sidenav.toggle();
    };
    /**
     * @return {?}
     */
    SidenavService.prototype.isOpen = /**
     * @return {?}
     */
    function () {
        return this.opened;
    };
    SidenavService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ SidenavService.ngInjectableDef = defineInjectable({ factory: function SidenavService_Factory() { return new SidenavService(); }, token: SidenavService, providedIn: "root" });
    return SidenavService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AlertDialogComponent = /** @class */ (function () {
    function AlertDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this.closeButton = 'CLOSE';
    }
    /**
     * @return {?}
     */
    AlertDialogComponent.prototype.onClose = /**
     * @return {?}
     */
    function () {
        this.dialogRef.close();
    };
    AlertDialogComponent.decorators = [
        { type: Component, args: [{
                    selector: 'crm--alert-dialog',
                    template: "<div>\n\n  <div mat-dialog-title>\n    <h3 class=\"crm-dialog-title\"> {{ title }} </h3>\n  </div>\n\n  <div mat-dialog-content class=\"crm-dialog-content\">\n    <span class=\"crm-dialog-message\"> {{ message }} </span>\n  </div>\n\n  <div mat-dialog-actions fxLayoutAlign=\"flex-end\">\n    <button mat-button color=\"accent\" (click)=\"onClose()\"> {{ closeButton }} </button>\n  </div>\n\n</div>\n\n<!--\n\n  <div mat-dialog-actions>\n    <button mat-button color=\"accent\" (click)=\"onClose()\"> {{ closeButton }} </button>\n  </div>\n\n  <div fxFlex fxLayout fxLayoutAlign=\"flex-end\">\n\n    <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n      <mat-icon>open_in_new</mat-icon>\n    </button>\n\n    <button mat-button class=\"crm-command-bar-button\" [disabled]=\"true\">\n      <mat-icon>clear</mat-icon>\n    </button>\n\n  </div>\n\n-->\n",
                    styles: [".crm-dialog-title{margin-top:0;margin-bottom:20px}.crm-dialog-content{margin-bottom:16px}.crm-dialog-message{word-break:break-word}"]
                }] }
    ];
    /** @nocollapse */
    AlertDialogComponent.ctorParameters = function () { return [
        { type: MatDialogRef }
    ]; };
    return AlertDialogComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DialogService = /** @class */ (function () {
    function DialogService(dialog) {
        this.dialog = dialog;
    }
    /**
     * @param {?} config
     * @return {?}
     */
    DialogService.prototype.openAlert = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var dialogConfig = this.createConfig(config);
        /** @type {?} */
        var dialogRef = this.dialog.open(AlertDialogComponent, dialogConfig);
        /** @type {?} */
        var alertDialogComponent = dialogRef.componentInstance;
        alertDialogComponent.title = config.title;
        alertDialogComponent.message = config.message;
        if (config.closeButton) {
            alertDialogComponent.closeButton = config.closeButton;
        }
        return dialogRef;
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    DialogService.prototype.createConfig = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var dialogConfig = new MatDialogConfig();
        dialogConfig.width = '400px';
        Object.assign(dialogConfig, config);
        return dialogConfig;
    };
    DialogService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DialogService.ctorParameters = function () { return [
        { type: MatDialog }
    ]; };
    /** @nocollapse */ DialogService.ngInjectableDef = defineInjectable({ factory: function DialogService_Factory() { return new DialogService(inject(MatDialog)); }, token: DialogService, providedIn: "root" });
    return DialogService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SerendipityComponentsModule = /** @class */ (function () {
    function SerendipityComponentsModule(logger) {
        this.logger = logger;
        this.logger.info('Serendipity Components Module initialised');
    }
    SerendipityComponentsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        AngularMaterialModule,
                        CommonModule,
                        FlexLayoutModule,
                        UtilsModule
                    ],
                    declarations: [AlertDialogComponent, ActivityBarComponent, CommandBarComponent],
                    providers: [
                        { provide: LoggerService, useClass: ConsoleLoggerService }
                    ],
                    exports: [ActivityBarComponent, CommandBarComponent],
                    entryComponents: [AlertDialogComponent]
                },] }
    ];
    /** @nocollapse */
    SerendipityComponentsModule.ctorParameters = function () { return [
        { type: LoggerService }
    ]; };
    return SerendipityComponentsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ActivityBarComponent, CommandBarComponent, DialogService, SerendipityComponentsModule, SidenavService, AlertDialogComponent as ɵa };
//# sourceMappingURL=serendipity-components.js.map
